export const transformArrayToCommaSeparatedString = (arr: string[] = []) =>
  arr.join(",");
